"use client";
import { Check, ChevronDown, ChevronUp } from "lucide-react";
import { useMemo, useState } from "react";

interface Attribute {
    name: string;
    value: string;
}

const MainAttribute = ({ data }: { data: Attribute[] }) => {
    const attributes = useMemo(() => data, [data]);
    const [showMore, setShowMore] = useState(false);

    return (
        <section
            className="w-full p-1 max-w-4xl mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-sm border-gray-200 dark:border-slate-700 my-8"
            aria-label="ویژگی‌های محصول"
        >
            <header className="flex items-center w-full my-4">
                <div className="flex-grow h-[1px]" style={{ backgroundColor: "#000" }} />
                <h2 className="mx-4 whitespace-nowrap text-sm font-bold text-[#274d15]" id="product-attributes-heading">
                    ویژگی‌های محصول
                </h2>
                <div className="flex-grow h-[1px]" style={{ backgroundColor: "#000" }} />
            </header>
            <div
                className={`transition-all duration-300 overflow-hidden ${showMore ? "max-h-full" : "max-h-80"
                    } md:max-h-full`}
                aria-labelledby="product-attributes-heading"
                tabIndex={0}
            >
                <dl className="flex flex-col">
                    {attributes.map((item: Attribute, index: number) => (
                        <div
                            key={index}
                            className="flex justify-between items-center text-sm border-b border-dashed py-2 px-3 even:bg-gray-100 dark:even:bg-slate-700 text-gray-700 dark:text-slate-300"
                        >
                            <dt className="font-semibold text-gray-600 dark:text-slate-200 min-w-[90px]">
                                {item.name}
                            </dt>
                            <dd className="text-gray-800 dark:text-slate-100 pr-4">
                                {item.value === "دارد" ? (
                                    <Check size={18} className="text-green-600 inline align-middle" aria-label="دارد" />
                                ) : (
                                    item.value
                                )}
                            </dd>
                        </div>
                    ))}
                </dl>
            </div>

            <div className="text-center mt-4 md:hidden">
                <button
                    onClick={() => setShowMore(!showMore)}
                    className="text-blue-600 hover:text-blue-800 text-sm flex items-center justify-center gap-1"
                    aria-expanded={showMore}
                    aria-controls="product-attributes-heading"
                    aria-label={showMore ? "بستن ویژگی‌ها" : "مشاهده بیشتر ویژگی‌های محصول"}
                >
                    {showMore ? "بستن" : "مشاهده بیشتر"}
                    {showMore ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </button>
            </div>
        </section>
    );
};

export default MainAttribute;
